export const setCurrencyList = (state, param) => {
  state.list = param.data.data.currency
}

export const setCurrentCurrencyId = (state, param) => {
  state.id = param.data.data.currency.id
  state.code = param.data.data.currency.code
  state.display = param.data.data.currency.display
  state.position = param.data.data.currency.position
  state.name_th = param.data.data.currency.name_th
  state.name_en = param.data.data.currency.name_en
}



// WEBPACK FOOTER //
// ./src/store/modules/currencies/mutations.js